export default "/assets/images/bigsneeze-circle.png?026b7ce97e085ed9cc2682351964d592";